import { PageProvider } from '../../../context/Page/page';
import { Content } from '../Content/Content';
import { Footer } from '../Footer/Footer';
import { Header } from '../Header/Header';
import { PageComponent } from './Page.types';
import css from './Page.module.scss';
import { useDevelopmentState } from '../../../context/Development/Development';

export const Page: PageComponent = ({
    customHeaderProps,
    showKioskBackground,
    showKioskBanner,
    suppressLocalizationButtons,
    suppressBanner,
    showSettingsButton,
    children,
}) => {
    const { isTimeoutDisabled } = useDevelopmentState();

    return (
        <PageProvider
            showKioskBackground={showKioskBackground}
            showKioskBanner={showKioskBanner}
            headerProps={customHeaderProps}
            suppressTimeout={isTimeoutDisabled}
        >
            <div className={css.page}>
                <Header
                    suppressLocalizationButtons={suppressLocalizationButtons}
                    suppressBanner={suppressBanner}
                    showSettingsButton={showSettingsButton}
                />
                <Content suppressLocalizationButtons={suppressLocalizationButtons}>{children}</Content>
                <Footer />
            </div>
        </PageProvider>
    );
};
